import qs from "qs";
import catalogs from "./submodules/catalogs";
import $utils from '@/utils';
import utils from '@/stores/utils';
import { CSV_EXPORT_LIMIT } from '@/constants/csv-export';

const { getStorageKey } = utils;

const state = {
    section: null,
};

const mutations = {
    updateSection(state, section) {
        state.section = section;
    },
};

const actions = {
    exportCatalogsAsCSV({ commit, dispatch, state }, params) {
        let filters = {};
        if (params.filtered) {
            filters = Object.assign({}, state.catalogs_filters);
            filters.offset = null;
        }
        filters.format = "csv";
        filters.limit = CSV_EXPORT_LIMIT;
        
        $utils.downloadFile({
            url: "/api/catalogs/",
            params: filters,
        }, $utils.getFilename('catalogs'));
    },

    exportStocksAsCSV({ commit, dispatch, state }, params) {
        const filters = {
            format: "csv",
            limit: CSV_EXPORT_LIMIT,
            type: "sell",
        };

        $utils.downloadFile({
            url: "/api/productcatalogentries/",
            params: filters,
        }, $utils.getFilename('catalogsStockExport'));
    },

    init({ commit, dispatch, state }, params) {
        return dispatch("catalogs/init", {
            storageOptions: {
                storageKey: getStorageKey('catalogs', 'default'),
                fieldsToSave: null,
            },
            filters: {
                ...(params?.filters || {}), type: "sell", limit: 20, ordering: 'provider_name,name'
            }
        });
    },
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    modules: {
        catalogs: catalogs({
            storageKey: getStorageKey('catalogs', 'default'),
            fieldsToSave: undefined // Save all filters
        }),
    },
};
